import Media from 'components/shared/Media/Media';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn } from 'utils/styles';
import { ExplainerSlideProps } from './types';

const ExplainerSlide = ({ sys, headline, copy, media, isActive = true }: ExplainerSlideProps) => {
  return (
    <div
      className={cn(
        'flex h-full flex-col max-sm:h-100 max-sm:justify-between gap-8 md:gap-20',
        !isActive && 'pointer-events-none',
      )}
      aria-hidden={!isActive}>
      <div className="flex flex-col gap-4 px-6 md:px-14">
        <div className="font-sans text-lg font-semibold md:text-heading-sm" {...liveUpdateAttrs(sys?.id, 'headline')}>
          <RichTextHeadline headline={headline} level="h3" />
        </div>
        {copy && (
          <div className="font-sans text-body-saans" {...liveUpdateAttrs(sys?.id, 'copy')}>
            <RichTextCopy copy={copy} ySpacing="none" />
          </div>
        )}
      </div>
      <div className="mt-auto w-full px-6 md:px-14" {...liveUpdateAttrs(sys?.id, 'media')}>
        <div className="relative aspect-4/3 w-full overflow-hidden">
          <Media
            media={{ ...media, fill: true }}
            roundedImage={false}
            loading="lazy"
            sizes="(max-width: 1024px) 100vw, 640px"
            className="object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default ExplainerSlide;
